import React, { PureComponent } from 'react';
import { FaUserPlus } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import dayjs from 'dayjs';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import styled from 'styled-components';

import Button from '../../components/button';
import Heading, { SubHeading } from '../../components/heading';
import ModalBase from '../../components/modal-base';
import {
  FlexedDetailContent,
  PaymentIcon,
  Wrapper
} from '../../components/review-payment';
import Detail from '../../components/review-payment/detail';
import TimeslotSelector from '../../components/timeslot-selector';
import { BOOKING_REGISTRATION_BOOKING_IDS_PARAM } from '../../constants';
import { gameChanged } from '../../modules/global/action-creators';
import getPaymentLogo from '../../utilities/get-payment-logo';

const Container = styled.div`
  margin: 1em auto 3em auto;
  &:not(:last-of-type) {
    padding-bottom: 3em;
    border-bottom: #00a4e9 1px solid;
  }
`;

const SelectorContainer = styled.div`
  display: flex;
  position: fixed;
  top: 4rem;
  width: 100%;
  padding: 0 2%;
  align-items: start;
  justify-content: center;
`;

const IconButton = styled(Button)`
  width: auto;
  height: auto;
  padding: 0.25em 0.75em;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  border-radius: 0.3em;

  > *:first-child {
    margin-right: 0.2em;
  }
`;

class Order extends PureComponent {
  state = {
    editingTimeslot: false,
    amount: null,
    numberOfTickets: null,
    scale: 'calendar'
  };
  componentDidMount() {
    if (this.props.timeslot) {
      this.setTimeslotInfo();
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.timeslot && this.props.timeslot) {
      this.setTimeslotInfo();
    }
  }
  setTimeslotInfo() {
    const date = dayjs.unix(this.props.timeslot.time);
    this.setState({
      amount: this.props.timeslot.amount,
      date,
      numberOfTickets:
        this.props.order.tickets ||
        Object.keys(this.props.order.bookings).length
    });
  }
  getPaymentInfo() {
    const { order } = this.props;
    if (!order.amount) {
      return;
    }
    let info;
    let card;
    let logo;
    switch (order.type) {
      case 'browser':
      case 'card':
        card = order.response.source;
        break;
      case 'konbini':
        logo = getPaymentLogo('konbini', order.store);
        break;
      default:
        // Legacy data structure
        card = order.source;
        break;
    }
    if (card) {
      logo = getPaymentLogo('card', card.brand.toLowerCase());
      info = `${card.last4}`;
    }
    return (
      <Detail title="paymentInfo">
        <FlexedDetailContent>
          {info}
          <PaymentIcon src={logo} />
        </FlexedDetailContent>
      </Detail>
    );
  }
  updateEmail = bookingId => value => {
    this.handleOrderEdit({
      bookings: {
        ...this.props.order.bookings,
        [bookingId]: value
      }
    });
  };
  handleOrderEdit(update) {
    this.props.firebase.update(
      `/orders/${this.props.uid}/${this.props.orderId}`,
      update
    );
  }
  handleTimeslotEditClick = () => {
    this.props.gameChanged(this.props.order.gameId);
    this.setState({
      editingTimeslot: true
    });
  };
  handleTimeChange = (scale, date) => {
    this.setState({ scale, date });
  };

  handleTimeslotSelect = timeslot => {
    this.handleOrderEdit({
      timeslotId: timeslot.key
    });
    this.handleModalClose();
  };
  handleModalClose = () => {
    this.setState({
      editingTimeslot: false
    });
  };
  blockClicks = ev => {
    ev.stopPropagation();
  };
  timeslotFilter = ({ value }) => {
    const remainingPlaces = value.playerCapacity - value.playerCount;
    if (this.state.numberOfTickets > remainingPlaces) {
      return false;
    }
    return value.amount === this.state.amount;
  };
  isNewEmailValid = email => {
    const lowerCaseEmail = email.toLowerCase();
    return !Object.values(this.props.order.bookings).some(
      existingEmail => existingEmail === lowerCaseEmail
    );
  };
  getEditLink() {
    let bookings = this.props.order.bookings;
    const urlParams = Object.keys(bookings).reduce(
      (params, bookingId) => {
        params.append(BOOKING_REGISTRATION_BOOKING_IDS_PARAM, bookingId);
        return params;
      },
      new URLSearchParams()
    );
    return `/games/${this.props.order.gameId}/register?${urlParams}`;
  }
  render() {
    const { order, activeLanguage, game, timeslot, bookings } = this.props;
    const bookingsInOrder = Object.keys(order.bookings || {}).map(
      bookingKey => bookings[bookingKey]
    );
    const canEdit = ['succeeded', 'captured'].indexOf(order.status) > -1;
    const canEditTimeslot =
      canEdit &&
      timeslot &&
      // Timeslot is in future or within the past month
      dayjs.unix(timeslot.time).isAfter(dayjs().subtract(1, 'month')) &&
      // None of the bookings have been marked as attended
      !bookingsInOrder.some(booking => !booking || booking.attended);

    // Continue's Order
    const isContinue = !!this.props.order.isContinue;

    return (
      <Container>
        <Heading fontSize="1em">{game && game.name}</Heading>
        <SubHeading fontSize="0.8em">
          {(order.createdAt || order.created) &&
            dayjs
              .unix(order.createdAt || order.created)
              .locale(activeLanguage.code)
              .format('YYYY年 M月 D日 (ddd)')}
        </SubHeading>
        <Wrapper>
          <Detail title="time">
            <>
              <div>
                {timeslot &&
                  dayjs
                    .unix(timeslot.time)
                    .locale(activeLanguage.code)
                    .format('YYYY年 M月 D日 (ddd) HH:mm ')}
              </div>
              {!isContinue && canEditTimeslot && (
                <div style={{ marginTop: '0.3em' }}>
                  <IconButton
                    onClick={this.handleTimeslotEditClick}
                    square
                    type="button"
                  >
                    <MdEdit />
                    <Translate id="editableField.edit" />
                  </IconButton>
                </div>
              )}
            </>
          </Detail>
          {this.getPaymentInfo()}
          {!!order.tickets && (
            <Detail title="tickets">
              <div>{order.tickets}</div>
              {!isContinue && canEdit && (
                <div style={{ marginTop: '0.3em' }}>
                  <IconButton as={Link} to={this.getEditLink()} type="none">
                    <FaUserPlus />
                    <Translate id="orders.playerRegistration" />
                  </IconButton>
                </div>
              )}
            </Detail>
          )}
          {order.coupons && (
            <Detail title="coupons">
              {order.coupons.map(coupon => (
                <div key={coupon}>{coupon}</div>
              ))}
            </Detail>
          )}
          <Detail title="total">{order.amount}円</Detail>
        </Wrapper>
        {canEditTimeslot && this.state.editingTimeslot && (
          <ModalBase onClose={this.handleModalClose}>
            <SelectorContainer>
              <TimeslotSelector
                date={this.state.date}
                filter={this.timeslotFilter}
                onClick={this.blockClicks}
                onTimeChange={this.handleTimeChange}
                onTimeslotSelect={this.handleTimeslotSelect}
                scale={this.state.scale}
                style={{
                  minHeight: '60vh',
                  maxHeight: 'calc(100vh - 5rem)',
                  flex: '1'
                }}
                timeslotFilter={this.timeslotFilter}
              />
            </SelectorContainer>
          </ModalBase>
        )}
      </Container>
    );
  }
}

Order.propTypes = {
  order: PropTypes.object.isRequired,
  orderId: PropTypes.string.isRequired,
  game: PropTypes.object,
  timeslot: PropTypes.object,
  uid: PropTypes.string.isRequired
};

/**
 * Map Redux State to props
 //  */
const mapStateToProps = ({ auth, firebase }, { order }) => {
  return {
    uid: auth.user.uid,
    timeslot: getVal(
      firebase.data,
      `/timeslots/${order.gameId}/${order.timeslotId}`
    ),
    bookings: getVal(firebase.data, `/bookings/${order.gameId}`) || {},
    games: getVal(firebase.data, '/games')
  };
};

/**
 * Map Redux Dispatch to props
 */
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      gameChanged
    },
    dispatch
  )
});

export default compose(
  withLocalize,
  connect(mapStateToProps, mapDispatchToProps),
  firebaseConnect(({ order }) => {
    return [
      `/timeslots/${order.gameId}/${order.timeslotId}`,
      ...Object.keys(order.bookings || {}).map(
        bookingKey => `/bookings/${order.gameId}/${bookingKey}`
      )
    ];
  })
)(Order);
